import { useOptions } from '@/component/Table/hooks/useOptions';
import { useTranslation } from '@/feature/lang';
import type { Column } from '@tanstack/react-table';
import { useMemo } from 'react';

// Translate value(s) of table cell using columns options specified in
// `columnDef.meta.options()`.
export const useTranslateValue = (
  value: unknown,
  column: Column<any> | undefined
) => {
  const options = useOptions(column);
  const { translate } = useTranslation();

  return useMemo(() => {
    if (options === undefined) {
      return value;
    }
    const lookup = (v: unknown) =>
      translate(options.find((option) => option.value === v)?.label) ?? v;

    return Array.isArray(value) ? value.map(lookup) : lookup(value);
  }, [options, value, translate]);
};
